<template>
  <div>
    <el-row type="flex" align="middle" :gutter="10">
      <el-col :span="16">
        <h3>Review & Publish Draw</h3>
        <span class="description"
          >
          The draw builder will allocate via. venue preference then field preference, if no slot is available it will allocate to the ‘time between matches setting’.<br />
          Verify all the below information is correct before saving the draw.
        </span>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" :gutter="10">
      <el-col :span="16">
        <el-row type="flex" align="middle">
          <h3>Venue Options</h3>
        </el-row>
        <!-- <el-row type="flex" align="middle">
          <h4>Venue Priotisation</h4>
        </el-row> -->
        <el-row type="flex" align="middle">
          <h4>Venue prioritisation and Field Assignment</h4>
        </el-row>
        <el-row :class="'venue-option'" align="middle" >
          <el-row :class="'venue-prioritisation'" type="flex" align="middle">
            <el-select
              value-key="_id"
              v-model="priorityDefault"
              placeholder="Select priotisation"
              size="medium"
            >
              <el-option
                v-for="{ label, value } of venuePriorityDefault"
                :label="label"
                :key="value"
                :value="value"
              >
              </el-option>
            </el-select>
            <el-tooltip class="item ml-2" effect="dark" placement="top-start" style="margin-bottom: 0.4rem;">
              <div slot="content" class="mb-2">Determines where the venues will come from. If an origin does not have a venue, the next origin that has a venue will be prioritised.</div>
              <div slot="content" class="mb-2">Note: Team venues will be based on the home team's venue.</div>
              <div slot="content" class="mb-2">Selection:</div>
              <div slot="content" class="mb-2">Default Venue Priority - Will get venues from teams, clubs, and competition</div>
              <div slot="content">User Preferred Venue Priority - Will get venues from the user selected origin. Arrange from left to right, left most being first priority and right most being last priority. Arrangement will be saved.</div>
              <i class="el-icon-info info"/>
            </el-tooltip>
            <!-- <el-button
              class="btn-highlight bottomBtn"
              @click.prevent="regenerateVenues"
            >
              Reprioritise
            </el-button> -->
          </el-row>
          <el-row type="flex" align="middle" v-if="priorityDefault === 1">
            <el-select
              value-key="_id"
              v-model="priorityVenue"
              placeholder="Select venue priotisation"
              size="medium"
              multiple
              @change="venuePriorityRearranged"
            >
              <el-option
                v-for="{ label, value } of venuePrioritySelection"
                :label="label"
                :key="value"
                :value="value"
              >
              </el-option>
            </el-select>
          </el-row>
        </el-row>
        <!-- <el-row type="flex" align="middle">
          <el-checkbox
            v-model="allocateFieldsFlag"
          >
            Allocate Fields
          </el-checkbox>
        </el-row> -->
        <el-row type="flex" align="middle">
          <el-button
            class="btn-highlight bottomBtn" :type="allocateFieldsFlag === false ? 'primary' : ''"
            @click.prevent="clickReallocateDefault"
          >
            Allocate Default Venue
          </el-button>
          <el-button
            class="btn-highlight bottomBtn" :type="allocateFieldsFlag === true ? 'primary' : ''"
            @click.prevent="clickReallocate"
          >
            Allocate Available Venue & fields
          </el-button>
          <el-tooltip class="item ml-2" effect="dark" placement="top-start" style="margin-bottom: 0.4rem;">
            <div slot="content" class="mb-2">Allocate Default Venue - Will allocate a unique venue to a match per round, fields will be empty</div>
            <div slot="content">Allocate Available Venue & fields - Will allocate available venues into each match per round. Available fields will be distributed per match per round.</div>
            <i class="el-icon-info info"/>
          </el-tooltip>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" class="mt-2" align="middle" :gutter="10">
      <el-col>
        <el-row type="flex" align="middle">
          <h3>Date & Time</h3>
        </el-row>
        <el-row>
          <el-button
            class="btn-highlight bottomBtn" :type="shuffleTimeFlag === false ? 'primary' : ''"
            @click.prevent="clickOriginalDateTime"
          >
            Original
          </el-button>
          <el-button
            class="btn-highlight bottomBtn" :type="shuffleTimeFlag === true ? 'primary' : ''"
            @click.prevent="clickShuffleDateTime"
          >
            Shuffle
          </el-button>
          <el-tooltip class="item ml-2" effect="dark" placement="top-start" style="margin-bottom: 0.4rem;">
            <div slot="content" class="mb-2">Original - Date & Time will be arranged in ascending order per round.</div>
            <div slot="content">Shuffle - Shuffles Date & Time per round. You can shuffle as much as you want.</div>
            <i class="el-icon-info info"/>
          </el-tooltip>
        </el-row>
      </el-col>
    </el-row>
    <div v-for="comp in value.competitions" :key="comp._id">
      <el-divider></el-divider>
      <el-table
        class="mt-1"
        :data="matches"
        v-for="{ name, teams, matches } in poolsFromComp(comp)"
        :key="`${name}-${key}`"
        :row-class-name="tableRowClassName"
        ref="tbl"
      >
        <el-table-column :label="name || ''" align="center">
          <el-table-column
            align="center"
            prop="round.number"
            label="Round"
            width="80"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="roundArrangement"
            label="Match Place"
            width="108"
          >
          </el-table-column>
          <el-table-column align="center" label="Home Team" width="auto">
            <template slot-scope="scope">
              <el-select
                value-key="_id"
                v-model="scope.row.homeTeam"
                placeholder="Select team"
                filterable
              >
                <el-option
                  v-for="{ _id, name } in teams"
                  :label="name"
                  :key="_id"
                  :value="{ _id, name }"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Away Team" width="auto">
            <template slot-scope="scope">
              <el-select
                value-key="_id"
                v-model="scope.row.awayTeam"
                placeholder="Select team"
                filterable
              >
                <el-option
                  v-for="{ _id, name } in teams"
                  :label="name"
                  :key="_id"
                  :value="{ _id, name }"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Date & Time" width="195">
            <template slot-scope="scope">
              <!-- <el-date-picker
                v-model="scope.row.dateTime"
                type="datetime"
                placeholder="Select date and time"
                format="dd/MM/yyyy HH:mm"
                value-format="timestamp"
                :clearable="false"
                :editable="false"
                v-if="!isBye(scope.row)"
              >
              </el-date-picker> -->
              <el-date-picker
                v-model="scope.row.dateTime"
                type="datetime"
                placeholder="Select date and time"
                format="dd/MM/yyyy HH:mm"
                value-format="timestamp"
                :clearable="false"
                :editable="false"
                v-if="!isBye(scope.row)"
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Venue" width="auto">
            <template slot-scope="scope">
              <el-select
                v-if="get(scope, 'row.homeTeam._id') !== 'BYE' && get(scope, 'row.awayTeam._id') !== 'BYE'"
                value-key="_id"
                v-model="scope.row.venue"
                placeholder="Select venue/type to search"
                :remote="true"
                :remote-method="searchVenue"
                @focus="searchVenueFocus"
                @change="() => venueChanged(scope.row, comp)"
                filterable
              >
                <el-option
                  v-for="{ _id, name, venueTimezone } in availableVenues(scope.row, comp)"
                  :label="name"
                  :key="_id"
                  :value="{ _id, name, venueTimezone }"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Field No" width="auto">
            <template slot-scope="scope">
              <el-select
                value-key="_id"
                v-model="scope.row.meta.field"
                placeholder="Select venue/type to search"
                size="medium"
                v-if="!isBye(scope.row)"
              >
                <el-option
                  v-for="{ _id, name } in getFields(scope.row.venue, comp)"
                  :label="name"
                  :key="_id"
                  :value="{ _id, name }"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-table :data="comp.final.matches" v-if="comp.final && comp.final.matches" border class="mt-1">
        <el-table-column label="Final Matches" align="center">
          <el-table-column
            align="center"
            prop="round.displayName"
            label="Round Name"
            width="auto"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="homeTeam.name"
            label="Home Team"
            width="auto"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="awayTeam.name"
            label="Away Team"
            width="auto"
          >
          </el-table-column>
          <el-table-column align="center" label="Date & Time" width="auto">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.dateTime"
                type="datetime"
                placeholder="Select date and time"
                format="dd/MM/yyyy HH:mm"
                value-format="timestamp"
                :clearable="false"
                :editable="false"
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Venue" width="auto">
            <template slot-scope="scope">
              <el-select
                value-key="_id"
                v-model="scope.row.venue"
                placeholder="Select venue/type to search"
                :remote="true"
                :remote-method="searchVenue"
                filterable
              >
                <el-option
                  v-for="{ _id, name, venueTimezone } in comp.venues"
                  :label="name"
                  :key="_id"
                  :value="{ _id, name, venueTimezone }"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Field No" width="auto">
            <template slot-scope="scope">
              <el-select
                value-key="_id"
                v-model="scope.row.meta.field"
                placeholder="Select venue/type to search"
                size="medium"
              >
                <!-- <el-option
                  v-for="{ _id, name } in getFields(scope.row.venue)"
                  :label="name"
                  :key="_id"
                  :value="{ _id, name }"
                >
                </el-option> -->
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <ActionBar>
      <!-- <div class="stats" v-click-outside="()=> statMini = true" @click="()=> statMini = false">
        <div class="mini" v-if="statMini" >
          <div class="mx-3 fs-13px">
            <fa-icon :icon="['fal', 'swords']" /> {{allMatches.length}}
          </div>
          <div class="fs-13px">
            <fa-icon :icon="['fal', 'circle-exclamation']" />  {{clashes.length}}
          </div>
        </div>
        <el-collapse-transition>
          <div class="large" v-if="!statMini">
            <div class="mx-3 fs-13px d-flex flex-align-items-center flex-column">
              <h5 class="mx-0 fs-15px">Total Matches</h5>
              <b>{{allMatches.length}}</b>
            </div>
            <div class="fs-13px d-flex flex-align-items-center flex-column">
              <h5 class="mx-0 fs-15px">Total Clashes</h5>
              <b>{{clashes.length}}</b>
            </div>
          </div>
        </el-collapse-transition>
      </div> -->
      <div>
        <el-tooltip content="Ignore clashes" placement="top" effect="dark">
          <el-button type="primary" circle class="" icon="el-icon-close" @click="checkClashesAndFixFieldNo"></el-button>
        </el-tooltip>
      </div>
      <div>
        <el-tooltip content="Submit Changes" placement="top" effect="dark">
          <el-button type="primary" circle class="" icon="el-icon-check" @click="checkClashes"></el-button>
        </el-tooltip>
      </div>
    </ActionBar>
  </div>
</template>
<script>
import ActionBar from '@/components/common/ActionBar.vue';
import vClickOutside from 'v-click-outside';
import { timedate } from '@/utils/timedate';
import {
} from '@/utils/constants';
import _, { } from 'lodash';

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: ['value', 'competition'],
  components: {
    ActionBar
  },
  data() {
    // const { drawbuilder } = this.competition;
    return {
      get: _.get,
      key: 0,
      // pickerOptions: {
      //   disabledDate(time) {
      //     return _.some(drawbuilder.skipDates, ({ from, to }) => from <= time.getTime() && time.getTime() <= to);
      //   },
      // },
      clashes: [],
      statMini: true,
      allMatches: [],
      venues: [],
      origMatches: [],
      // originalMatchTimeFlag: true,
      venuePriorityDefault: [
        { label: 'Default Venue Priority (Team, Club, Competition)', value: 0 },
        { label: 'User Preferred Venue Priority', value: 1 },
      ],
      venuePrioritySelection: [
        { label: 'Team Primary Venue', value: 0 },
        { label: 'Team 2nd Venue', value: 1 },
        { label: 'Club Primary Venue', value: 2 },
        { label: 'Club 2nd Venue', value: 3 },
        { label: 'Competition Primary Venue', value: 4 },
        { label: 'Competition 2nd Venue', value: 5 }
      ],
      priorityDefault: 0,
      priorityVenue: [],
      allocateFieldsFlag: true,
      shuffleTimeFlag: false,
      origVenueResponse: {},
      searchQuery: '',
      rerender: false,
      initialRegenerate: true,
    };
  },
  async mounted() {
    console.log({
      value: this.value,
    });
    // eslint-disable-next-line no-restricted-syntax
    for (const comp of this.value.competitions) {
      try {
        // eslint-disable-next-line no-await-in-loop
        const res = await this.$http.get(`assemble/api/v1/admin/venues/competitions/${comp._id}`);
        comp.origVenueResponse = res.data.data;
        const { clubVenues, teamVenues, compVenues } = res.data.data;
        const resultVenues = [
          { _id: undefined, name: '', venueTimezone: undefined },
        ];
        // Place Team Venues to Venues List
        teamVenues.forEach((item, i) => {
          const teamVenue = item.venue;
          const teamVenue2 = item.secondaryVenue;
          if (teamVenue && Object.keys(teamVenue).length !== 0) {
            teamVenue.unavailableDates = item.unavailableDates;
            teamVenue.priorityType = 0;
            resultVenues.push(teamVenue);
          }
          if (teamVenue2 && Object.keys(teamVenue2).length !== 0) {
            teamVenue2.unavailableDates = item.secondaryUnavailableDates;
            teamVenue2.priorityType = 1;
            resultVenues.push(teamVenue2);
          }
        });
        // Place Club Venues to Venues List
        clubVenues.forEach((item, i) => {
          const clubVenue = item.venue;
          const clubVenue2 = item.secondaryVenue;
          if (clubVenue && Object.keys(clubVenue).length !== 0) {
            clubVenue.unavailableDates = item.unavailableDates;
            clubVenue.priorityType = 2;
            resultVenues.push(clubVenue);
          }
          if (clubVenue2 && Object.keys(clubVenue2).length !== 0) {
            clubVenue2.unavailableDates = item.secondaryUnavailableDates;
            clubVenue2.priorityType = 3;
            resultVenues.push(clubVenue2);
          }
        });
        // Place Competition Venues to Venues List
        compVenues.forEach((item, i) => {
          const compVenue = item.venue;
          const compVenue2 = item.secondaryVenue;
          const compVenueAdditional = item.additionalVenues || [];
          if (compVenue && Object.keys(compVenue).length !== 0) {
            compVenue.unavailableDates = item.unavailableDates;
            compVenue.priorityType = 4;
            resultVenues.push(compVenue);
          }
          if (compVenue2 && Object.keys(compVenue2).length !== 0) {
            compVenue2.unavailableDates = item.secondaryUnavailableDates;
            compVenue2.priorityType = 5;
            resultVenues.push(compVenue2);
          }

          compVenueAdditional.forEach((venue, vIndex) => {
            const currentVenue = venue;
            currentVenue.unavailableDates = _.get(venue, 'meta.unavailableDates');
            currentVenue.priorityType = 5 + vIndex + 1;
            resultVenues.push(currentVenue);
            const newVenueLabel = `Competition Additional Venue - ${this.getAdditionalPriority(vIndex)}`;
            const newVenueIndex = 5 + vIndex + 1;
            comp.venuePrioritySelection.push({
              label: newVenueLabel,
              value: newVenueIndex,
            });
            if (!this.priorityVenue.find((v) => v === newVenueIndex)) this.priorityVenue.push(newVenueIndex);
            this.priorityVenue = this.priorityVenue.filter((v, index) => this.priorityVenue.indexOf(v) === index);
          });
        });
        comp.venues = resultVenues;
        // this.checkClashes();
      } catch (error) {
        console.log(error);
      }

      let _id = 0;
      if (this.value.drawType === 0) {
        _.forEach(comp.pools, ({ matches }) => {
          comp.allMatches = _.concat(comp.allMatches, _.map(matches, (m) => _.assign(m, { _id: _id++ })));
        });
      }
      console.log({
        allMatches: comp.allMatches,
      });
      comp.allMatches.forEach((match, i) => {
        comp.allMatches[i].meta.originalDateTime = match.dateTime;
        comp.allMatches[i].meta.field = {};
      });
      this.priorityVenue = this.$store.getters['user/drawVenuePriority'];
      comp.pools.forEach((pool) => {
        for (let i = 0; i < pool.roundDates.length; i++) {
          const round = i + 1;
          const roundValues = _.filter(pool.matches, (match) => match.round.number === round);
          roundValues.forEach((item, index) => {
            roundValues[index].roundArrangement = `${round}.${index + 1}`;
          });
        }
      });
    }
    // eslint-disable-next-line no-await-in-loop
    await this.regenerateVenues('mounted');
    // this.$http.get(`assemble/api/v1/admin/venues/competitions/${this.competition._id}`)
    //   .then((res) => {
    //     this.origVenueResponse = res.data.data;
    //     const { clubVenues, teamVenues, compVenues } = res.data.data;
    //     const resultVenues = [
    //       { _id: undefined, name: '', venueTimezone: undefined },
    //     ];
    //     // Place Team Venues to Venues List
    //     teamVenues.forEach((item, i) => {
    //       const teamVenue = item.venue;
    //       const teamVenue2 = item.secondaryVenue;
    //       if (teamVenue && Object.keys(teamVenue).length !== 0) {
    //         teamVenue.unavailableDates = item.unavailableDates;
    //         teamVenue.priorityType = 0;
    //         resultVenues.push(teamVenue);
    //       }
    //       if (teamVenue2 && Object.keys(teamVenue2).length !== 0) {
    //         teamVenue2.unavailableDates = item.secondaryUnavailableDates;
    //         teamVenue2.priorityType = 1;
    //         resultVenues.push(teamVenue2);
    //       }
    //     });
    //     // Place Club Venues to Venues List
    //     clubVenues.forEach((item, i) => {
    //       const clubVenue = item.venue;
    //       const clubVenue2 = item.secondaryVenue;
    //       if (clubVenue && Object.keys(clubVenue).length !== 0) {
    //         clubVenue.unavailableDates = item.unavailableDates;
    //         clubVenue.priorityType = 2;
    //         resultVenues.push(clubVenue);
    //       }
    //       if (clubVenue2 && Object.keys(clubVenue2).length !== 0) {
    //         clubVenue2.unavailableDates = item.secondaryUnavailableDates;
    //         clubVenue2.priorityType = 3;
    //         resultVenues.push(clubVenue2);
    //       }
    //     });
    //     // Place Competition Venues to Venues List
    //     compVenues.forEach((item, i) => {
    //       const compVenue = item.venue;
    //       const compVenue2 = item.secondaryVenue;
    //       const compVenueAdditional = item.additionalVenues || [];
    //       if (compVenue && Object.keys(compVenue).length !== 0) {
    //         compVenue.unavailableDates = item.unavailableDates;
    //         compVenue.priorityType = 4;
    //         resultVenues.push(compVenue);
    //       }
    //       if (compVenue2 && Object.keys(compVenue2).length !== 0) {
    //         compVenue2.unavailableDates = item.secondaryUnavailableDates;
    //         compVenue2.priorityType = 5;
    //         resultVenues.push(compVenue2);
    //       }

    //       compVenueAdditional.forEach((venue, vIndex) => {
    //         const currentVenue = venue;
    //         currentVenue.unavailableDates = _.get(venue, 'meta.unavailableDates');
    //         currentVenue.priorityType = 5 + vIndex + 1;
    //         resultVenues.push(currentVenue);
    //         const newVenueLabel = `Competition Additional Venue - ${this.getAdditionalPriority(vIndex)}`;
    //         const newVenueIndex = 5 + vIndex + 1;
    //         this.venuePrioritySelection.push({
    //           label: newVenueLabel,
    //           value: newVenueIndex,
    //         });
    //         if (!this.priorityVenue.find((v) => v === newVenueIndex)) this.priorityVenue.push(newVenueIndex);
    //         this.priorityVenue = this.priorityVenue.filter((v, index) => this.priorityVenue.indexOf(v) === index);
    //       });
    //     });
    //     this.venues = resultVenues;
    //     this.regenerateVenues();
    //     this.checkClashes();
    //   }).catch((error) => {
    //     console.log(error);
    //   });

    // this.origMatches = JSON.parse(JSON.stringify(this.allMatches));
    // this.checkClashes();
  },
  methods: {
    poolsFromComp(comp) {
      console.log({
        pools: comp.pools,
      });
      return _.get(comp, 'pools', []);
    },
    searchVenueFocus() {
      this.searchQuery = '';
    },
    getAdditionalPriority(index) {
      const priority = index + 3;
      // eslint-disable-next-line no-nested-ternary
      const text = priority % 10 === 1 && priority !== 11 ? `${priority}st`
      // eslint-disable-next-line no-nested-ternary
        : priority % 10 === 2 && priority !== 12 ? `${priority}nd`
          : priority % 10 === 3 && priority !== 13 ? `${priority}rd`
            : `${priority}th`;
      return `${text} priority`;
    },
    isBye(matchRow) {
      if (_.get(matchRow, 'homeTeam._id') === 'BYE' || _.get(matchRow, 'awayTeam._id') === 'BYE') {
        return true;
      }
      return false;
    },
    availableVenues(match, comp) {
      const { dateTime } = match;
      const isAvailable = (unavailableDates, time) => _.every(unavailableDates, ({ from, to }) => {
        const formattedTo = this.moment(to)
          .set('hour', 23)
          .set('minutes', 59)
          .set('seconds', 59)
          .valueOf();
        return time < from || time > formattedTo;
      });
      let venues = [];
      if (this.priorityDefault !== 0) {
        // If user priority venues is chosen
        // Filter Venues based on priority type, see venuePrioritySelection
        console.log({
          priorityVenue: this.priorityVenue,
        });
        this.priorityVenue.forEach((itemIndex) => {
          const filteredVenues = _.filter(comp.venues, (v) => v.priorityType === itemIndex);
          venues = venues.concat(filteredVenues);
        });
      } else {
        // If default venues is chosen
        venues = comp.venues;
      }
      // Filter out undefined venues
      venues = _.filter(venues, (venue) => venue !== undefined);
      venues = _.filter(venues, (venue) => venue._id !== undefined);
      // Filter out venues with unavailable venue dates
      venues = _.filter(venues, ({ unavailableDates }) => isAvailable(unavailableDates, dateTime));
      if (venues.length < 1) {
        return [{ _id: undefined, name: '', venueTimezone: undefined }];
      }
      venues.push({ _id: undefined, name: '', venueTimezone: undefined });
      // Used if user has type something into the venue search
      venues = _.filter(venues, (venue) => _.get(venue, 'name', '').toLowerCase().includes(this.searchQuery.toLowerCase()));
      // Filter unique venues only
      const uniqueVenueIds = [];
      const uniqueVenues = _.filter(venues, (v) => {
        if (!uniqueVenueIds.includes(v._id)) {
          uniqueVenueIds.push(v._id);
          return true;
        }
        return false;
      });
      return uniqueVenues;
    },
    timedateObj() {
      return timedate;
    },
    venuePriorityRearranged() {
      this.$store.dispatch('user/savePreference', { venuepriority: this.priorityVenue });
    },
    venueChanged(argMatch, comp) {
      console.log('venueChanged');
      console.log({
        argMatch,
        comp,
        allMatches: comp.allMatches,
      });
      // const match = _.find(comp.allMatches, argMatch);
      // const fields = this.getFields(match.venue, comp);
      // console.log({
      //   fields
      // });
      // match.meta.field = _.head(fields);
      // match.meta.field = {};
    },
    venueFinalChanged(argMatch, comp) {
      const match = argMatch;
      const fields = this.getFields(match.venue, comp);
      match.meta.field = {};
      // match.meta.field = _.head(fields);
    },
    rearrangeRoundsByTime(comp) {
      comp.pools.forEach((pool, poolIndex) => {
        let newMatchArrangement = [];
        for (let i = 0; i < pool.roundDates.length; i++) {
          const round = i + 1;
          const roundValues = _.filter(pool.matches, (match) => match.round.number === round);
          const sortedRoundValues = _.sortBy(roundValues, (match) => match.dateTime);
          newMatchArrangement = _.concat(newMatchArrangement, sortedRoundValues);
        }
        // eslint-disable-next-line no-param-reassign
        comp.pools[poolIndex].matches = newMatchArrangement;
      });
      this.rerender = !this.rerender;
    },
    async clickReallocateDefault() {
      const confirm = await this.$confirm('This will modify your matches by allocating a unique venue in a single match per round, fields will be emptied. Do you want to continue?', 'Warning (Allocate Default Venue)', {});
      if (confirm) {
        this.allocateFieldsFlag = false;
        await this.regenerateVenues('reallocateDefault');
        this.$message.success('Allocate Default Venue Successful');
      }
    },
    async clickReallocate() {
      const confirm = await this.$confirm('This will modify your matches by allocating available venues and distributing their fields per match per round. Do you want to continue?', 'Warning (Allocate Available Venue & fields)', {});
      if (confirm) {
        this.allocateFieldsFlag = true;
        await this.regenerateVenues('reallocate');
        this.$message.success('Allocate Available Venue & Fields Successful');
      }
    },
    async clickOriginalDateTime() {
      this.$store.commit('loading', true);
      this.shuffleTimeFlag = false;
      this.setOriginalMatchesDateTime();
      this.$message.success('Original Date & Time Successful');
      this.$store.commit('loading', false);
    },
    async clickShuffleDateTime() {
      this.$store.commit('loading', true);
      this.shuffleTimeFlag = true;
      this.randomizeDateTime();
      this.$message.success('Shuffle Date & Time Successful');
      this.$store.commit('loading', false);
    },
    allocateField(comp) {
      this.allocateVenue(comp);
      comp.pools.forEach((pool, poolIndex) => {
        const venues = _.cloneDeep(comp.venues);
        venues.forEach(({ fields }, indexVenue) => {
          if (fields && fields.length > 0) {
            fields.forEach((field, i) => {
              venues[indexVenue].fields[i].isAllocated = false;
            });
          }
        });
        const rounds = [];
        comp.pools[poolIndex].matches.forEach((item, index) => {
          const itemRound = item.round.number;
          const roundIndex = itemRound - 1;
          if (rounds[roundIndex] === undefined) rounds[roundIndex] = _.cloneDeep(venues);
        });
        comp.pools[poolIndex].matches.forEach((match, i) => {
          const {
            homeTeam, awayTeam, meta, round, venue
          } = match;
          if (_.get(homeTeam, '_id') !== 'BYE' && _.get(awayTeam, '_id') !== 'BYE') {
            if (this.allocateFieldsFlag === true) {
              const foundVenue = _.find(rounds[round.number - 1], (roundVenue) => roundVenue._id === venue._id);
              if (foundVenue && foundVenue.fields && foundVenue.fields.length > 0) {
                let hasBeenAllocated = false;
                foundVenue.fields.forEach((field, fieldIndex) => {
                  if (hasBeenAllocated === false) {
                    if (field.isAllocated === false) {
                      // eslint-disable-next-line no-param-reassign
                      comp.pools[poolIndex].matches[i].meta.field = foundVenue.fields[fieldIndex];
                      foundVenue.fields[fieldIndex].isAllocated = true;
                      hasBeenAllocated = true;
                    }
                  }
                });
              }
            } else {
              this.venueChanged(match, comp);
            }
          }
        });
      });
    },
    allocateVenue(comp) {
      if (this.allocateFieldsFlag === false) {
        comp.pools.forEach((pool, poolIndex) => {
          const availableVenues = [];
          pool.roundDates.forEach((round, i) => {
            const venues = _.cloneDeep(comp.venues);
            console.log({
              venues,
              comp
            });
            try {
              venues.shift();
              availableVenues.push(venues);
            } catch (error) {
              console.log(error);
            }
          });
          pool.matches.forEach((match, i) => {
            const foundMatch = comp.allMatches.find((m) => m._id === match._id);
            // eslint-disable-next-line no-param-reassign
            if (foundMatch) comp.pools[poolIndex].matches[i].venue = foundMatch.venue;
            else if (_.find(availableVenues[match.round.number - 1], (av) => av._id === match.venue._id)) {
              if (_.get(match, 'homeTeam._id') !== 'BYE' && _.get(match, 'awayTeam._id') !== 'BYE') {
                availableVenues[match.round.number - 1] = _.filter(availableVenues[match.round.number - 1], (av) => av._id !== match.venue._id);
                // eslint-disable-next-line no-param-reassign
                comp.pools[poolIndex].matches[i].venue = availableVenues[match.round.number - 1][0] || { _id: undefined, name: '', venueTimezone: undefined };
              }
            } else {
              // eslint-disable-next-line no-param-reassign
              comp.pools[poolIndex].matches[i].venue = { _id: undefined, name: '', venueTimezone: undefined };
            }
            this.venueChanged(match, comp);
          });
        });
      }
    },
    async regenerateVenues(regenFrom) {
      console.log({
        ReGenFrom: regenFrom,
      });
      // eslint-disable-next-line no-restricted-syntax
      for (const comp of this.value.competitions) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const res = await this.$http.get(`assemble/api/v1/admin/venues/competitions/${comp._id}`);
          const { clubVenues, teamVenues, compVenues } = res.data.data;
          console.log({
            comp,
            clubVenues,
            teamVenues,
            compVenues,
          });
          const findMatchVenue = (teamId, dateTime) => {
            const isAvailable = (unavailableDates, time) => _.every(unavailableDates, ({ from, to }) => {
              const formattedTo = this.moment(to)
                .set('hour', 23)
                .set('minutes', 59)
                .set('seconds', 59)
                .valueOf();
              return time < from || time > formattedTo;
            });
            // Getting Competition Venues
            const compVenue = _.find(compVenues, (c) => isAvailable(c.unavailableDates, dateTime));
            const comp2ndVenue = _.find(compVenues, (c) => isAvailable(c.secondaryUnavailableDates, dateTime));
            const competitionResult = (compVenue && compVenue.venue);
            const competitionResult2 = (comp2ndVenue && comp2ndVenue.secondaryVenue);
            const hasAdditionalVenues = (compVenues.find((c) => c.additionalVenues && c.additionalVenues.length > 0) || false);
            const competitionAdditional = hasAdditionalVenues
              ? hasAdditionalVenues.additionalVenues.filter((v) => isAvailable(_.get(v, 'meta.unavailableDates', []), dateTime))
              : [];

            // Getting Team Venues
            const teamVenue = _.find(teamVenues, (x) => x._id === teamId && isAvailable(x.unavailableDates, dateTime));
            const team2ndVenue = _.find(teamVenues, (x) => x._id === teamId && isAvailable(x.secondaryUnavailableDates, dateTime));
            const teamResult = (teamVenue && teamVenue.venue);
            const teamResult2 = (team2ndVenue && team2ndVenue.secondaryVenue);
            // Getting Club Venues
            const team = _.find(comp.teams, (t) => t._id === teamId);
            const clubVenue = _.find(clubVenues, (x) => x._id === _.get(team, 'orgtree.club._id') && isAvailable(x.unavailableDates, dateTime));
            const club2ndVenue = _.find(clubVenues, (x) => x._id === _.get(team, 'orgtree.club._id') && isAvailable(x.secondaryUnavailableDates, dateTime));
            const clubResult = (clubVenue && clubVenue.venue);
            const clubResult2 = (club2ndVenue && club2ndVenue.secondaryVenue);
            const priority = [teamResult, teamResult2, clubResult, clubResult2, competitionResult, competitionResult2, ...competitionAdditional];
            let result = {};
            if (this.priorityDefault === 0) {
              const available = _.find(priority.concat({ _id: undefined, name: '', venueTimezone: undefined }), (v) => v && _.get(v, 'name'));
              result = available;
            } else {
              let tempResult;
              this.priorityVenue.forEach((item, i) => {
                tempResult = tempResult || priority[item];
              });
              result = tempResult || { _id: undefined, name: '', venueTimezone: undefined };
            }

            if (result) return result;
            return { _id: undefined, name: '', venueTimezone: undefined };
          };

          this.$set(comp, 'allMatches', Object.assign([], comp.allMatches.map((match) => {
            try {
              const { homeTeam, dateTime, roundArrangement } = match;
              const matchVenue = findMatchVenue(_.get(homeTeam, '_id'), dateTime);
              console.log({
                matchVenue,
              });

              return {
                ...match,
                venue: matchVenue
              };
            } catch (e) {
              console.log(e);
            }
            return match;
          })));

          comp.allMatches.forEach((match) => {
            this.venueChanged(match, comp);
          });

          this.allocateVenue(comp);

          if (this.allocateFieldsFlag === true) {
            this.allocateField(comp);
          }

          this.$store.commit('loading', false);
          // return true;
        } catch (error) {
          console.log(error);
          this.$store.commit('loading', false);
        }
      }
      this.putBackOriginalData();
      // this.$http.get(`assemble/api/v1/admin/venues/competitions/${this.competition._id}`)
      //   .then((res) => {
      //     const { clubVenues, teamVenues, compVenues } = res.data.data;
      //     const findMatchVenue = (teamId, dateTime) => {
      //       const isAvailable = (unavailableDates, time) => _.every(unavailableDates, ({ from, to }) => {
      //         const formattedTo = this.moment(to)
      //           .set('hour', 23)
      //           .set('minutes', 59)
      //           .set('seconds', 59)
      //           .valueOf();
      //         return time < from || time > formattedTo;
      //       });
      //       // Getting Competition Venues
      //       const compVenue = _.find(compVenues, (c) => isAvailable(c.unavailableDates, dateTime));
      //       const comp2ndVenue = _.find(compVenues, (c) => isAvailable(c.secondaryUnavailableDates, dateTime));
      //       const competitionResult = (compVenue && compVenue.venue);
      //       const competitionResult2 = (comp2ndVenue && comp2ndVenue.secondaryVenue);
      //       const hasAdditionalVenues = (compVenues.find((c) => c.additionalVenues && c.additionalVenues.length > 0) || false);
      //       const competitionAdditional = hasAdditionalVenues
      //         ? hasAdditionalVenues.additionalVenues.filter((v) => isAvailable(_.get(v, 'meta.unavailableDates', []), dateTime))
      //         : [];

      //       // Getting Team Venues
      //       const teamVenue = _.find(teamVenues, (x) => x._id === teamId && isAvailable(x.unavailableDates, dateTime));
      //       const team2ndVenue = _.find(teamVenues, (x) => x._id === teamId && isAvailable(x.secondaryUnavailableDates, dateTime));
      //       const teamResult = (teamVenue && teamVenue.venue);
      //       const teamResult2 = (team2ndVenue && team2ndVenue.secondaryVenue);
      //       // Getting Club Venues
      //       const team = _.find(this.competition.teams, (t) => t._id === teamId);
      //       const clubVenue = _.find(clubVenues, (x) => x._id === _.get(team, 'orgtree.club._id') && isAvailable(x.unavailableDates, dateTime));
      //       const club2ndVenue = _.find(clubVenues, (x) => x._id === _.get(team, 'orgtree.club._id') && isAvailable(x.secondaryUnavailableDates, dateTime));
      //       const clubResult = (clubVenue && clubVenue.venue);
      //       const clubResult2 = (club2ndVenue && club2ndVenue.secondaryVenue);
      //       const priority = [teamResult, teamResult2, clubResult, clubResult2, competitionResult, competitionResult2, ...competitionAdditional];
      //       let result = {};
      //       if (this.priorityDefault === 0) {
      //         const available = _.find(priority.concat({ _id: undefined, name: '', venueTimezone: undefined }), (v) => v && v.name);
      //         result = available;
      //       } else {
      //         let tempResult;
      //         this.priorityVenue.forEach((item, i) => {
      //           tempResult = tempResult || priority[item];
      //         });
      //         result = tempResult || { _id: undefined, name: '', venueTimezone: undefined };
      //       }

      //       if (result) return result;
      //       return { _id: undefined, name: '', venueTimezone: undefined };
      //     };

      //     this.$set(this, 'allMatches', Object.assign([], this.allMatches.map((match) => {
      //       try {
      //         const { homeTeam, dateTime, roundArrangement } = match;
      //         const matchVenue = findMatchVenue(homeTeam._id, dateTime);

      //         return {
      //           ...match,
      //           venue: matchVenue
      //         };
      //       } catch (e) {
      //         console.log(e);
      //       }
      //       return match;
      //     })));

      //     this.allMatches.forEach((match) => {
      //       this.venueChanged(match);
      //     });

      //     this.allocateVenue();

      //     if (this.allocateFieldsFlag === true) {
      //       this.allocateField();
      //     }

      //     this.$store.commit('loading', false);
      //     return true;
      //   }).catch((error) => {
      //     if (error.response) {
      //       this.$message.error(error.response.data.message);
      //     }
      //     this.$store.commit('loading', false);
      //     return false;
      //   });
    },
    putBackOriginalData() {
      // eslint-disable-next-line no-restricted-syntax
      for (const comp of this.value.competitions) {
        console.log({
          initialRegenerate: this.initialRegenerate,
        });
        if (this.value.drawType === 1) {
          // eslint-disable-next-line no-restricted-syntax
          for (const pool of comp.pools) {
            // eslint-disable-next-line no-restricted-syntax
            for (const match of pool.matches) {
              // There is an originalTime in each match
              // We need to change the HH:mm in the dateTime to the originalTime HH:mm
              const originalTime = this.moment(match.originalTime).format('HH:mm');
              const dateTime = this.moment(match.dateTime);
              dateTime.set('hour', this.moment(originalTime, 'HH:mm').hour());
              dateTime.set('minute', this.moment(originalTime, 'HH:mm').minute());
              const originalMatchId = _.get(match, 'originalData._id');
              match._id = originalMatchId;
              match.dateTime = dateTime.valueOf();
              if (this.initialRegenerate) {
                console.log('Regenerate Original');
                match.venue = _.get(match, 'originalVenue');
                match.meta = _.get(match, 'originalMeta');
              }
            }
          }

          const finalsMatches = _.get(comp, 'final.matches', []);
          const originalFinalMatches = _.get(comp, 'originalFinalMatches', []);
          console.log({
            finalsMatches
          });
          const groupFinalsByRoundNumber = _.groupBy(finalsMatches, 'round.number');
          const groupOriginalFinalsByRoundNumber = _.groupBy(originalFinalMatches, 'round.number');
          console.log({
            groupFinalsByRoundNumber,
            groupOriginalFinalsByRoundNumber,
          });
          const groupFinalsByRoundNumberKeys = _.keys(groupFinalsByRoundNumber);
          // Iterate through each group of finals by round number
          // Put the original data to the finals matches same row
          // The ones in the groupFinalsByRoundNumber don't have _id so we need to match by row number
          try {
            console.log('Regenerate Finals');
            // eslint-disable-next-line no-restricted-syntax
            for (const key of groupFinalsByRoundNumberKeys) {
              const groupFinals = _.get(groupFinalsByRoundNumber, key, []);
              const groupOriginalFinals = _.get(groupOriginalFinalsByRoundNumber, key, []);
              console.log({
                groupFinals,
                groupOriginalFinals
              });
              // eslint-disable-next-line no-restricted-syntax
              for (let j = 0; j < groupFinals.length; j++) {
                const finalMatch = groupFinals[j];
                const originalFinalMatch = groupOriginalFinals[j];
                console.log({
                  finalMatch,
                  originalFinalMatch,
                });
                finalMatch._id = originalFinalMatch._id;
                finalMatch.venue = originalFinalMatch.venue;
                finalMatch.meta = originalFinalMatch.meta;
                const dateTime = this.moment(finalMatch.dateTime);
                dateTime.set('hour', this.moment(originalFinalMatch.dateTime).hour());
                dateTime.set('minute', this.moment(originalFinalMatch.dateTime).minute());
                finalMatch.dateTime = dateTime.valueOf();
              }
            }
          } catch (e) {
            console.log('Error on Regenerate Finals');
            console.log(e);
          }
        }
        console.log({
          competitions: this.value.competitions
        });
      }
      this.initialRegenerate = false;
    },
    randomizeDateTime() {
      // eslint-disable-next-line no-restricted-syntax
      for (const comp of this.value.competitions) {
        // eslint-disable-next-line no-undef
        comp.pools.forEach((pool, poolIndex) => {
          // Put rounds and its items' datetime to array
          const roundsDateTime = [];
          const roundsArrPos = [];
          pool.matches.forEach((item, index) => {
            const itemRound = item.round.number;
            const roundIndex = itemRound - 1;
            if (roundsDateTime[roundIndex] === undefined) roundsDateTime[roundIndex] = [];
            if (roundsArrPos[roundIndex] === undefined) roundsArrPos[roundIndex] = [];
            // Only matches that are not BYE will be included in the randomizable datetime
            if (_.get(item, 'homeTeam._id') !== 'BYE' && _.get(item, 'awayTeam._id') !== 'BYE') {
              roundsDateTime[roundIndex].push(item.dateTime);
              roundsArrPos[roundIndex].push(index);
            }
          });
          // Shuffle each round's datetime
          roundsDateTime.forEach((item, i) => {
            roundsDateTime[i] = _.shuffle(roundsDateTime[i]);
          });
          // Place the shuffled datetime into the matches
          roundsDateTime.forEach((matches, roundIndex) => {
            matches.forEach((matchDateTime, matchIndex) => {
              // eslint-disable-next-line no-undef
              comp.pools[poolIndex].matches[roundsArrPos[roundIndex][matchIndex]].dateTime = matchDateTime;
            });
          });
        });
        this.rearrangeRoundsByTime();
      }
      // // eslint-disable-next-line no-undef
      // comp.pools.forEach((pool, poolIndex) => {
      //   // Put rounds and its items' datetime to array
      //   const roundsDateTime = [];
      //   const roundsArrPos = [];
      //   pool.matches.forEach((item, index) => {
      //     const itemRound = item.round.number;
      //     const roundIndex = itemRound - 1;
      //     if (roundsDateTime[roundIndex] === undefined) roundsDateTime[roundIndex] = [];
      //     if (roundsArrPos[roundIndex] === undefined) roundsArrPos[roundIndex] = [];
      //     // Only matches that are not BYE will be included in the randomizable datetime
      //     if (item.homeTeam._id !== 'BYE' && item.awayTeam._id !== 'BYE') {
      //       roundsDateTime[roundIndex].push(item.dateTime);
      //       roundsArrPos[roundIndex].push(index);
      //     }
      //   });
      //   // Shuffle each round's datetime
      //   roundsDateTime.forEach((item, i) => {
      //     roundsDateTime[i] = _.shuffle(roundsDateTime[i]);
      //   });
      //   // Place the shuffled datetime into the matches
      //   roundsDateTime.forEach((matches, roundIndex) => {
      //     matches.forEach((matchDateTime, matchIndex) => {
      //       // eslint-disable-next-line no-undef
      //       comp.pools[poolIndex].matches[roundsArrPos[roundIndex][matchIndex]].dateTime = matchDateTime;
      //     });
      //   });
      // });
      // this.rearrangeRoundsByTime();
    },
    setOriginalMatchesDateTime() {
      // eslint-disable-next-line no-undef
      comp.pools.forEach((pool, poolIndex) => {
        const originalOrderMatches = _.orderBy(pool.matches, ['roundArrangement'], ['asc']);
        originalOrderMatches.forEach((match, i) => {
          originalOrderMatches[i].dateTime = match.meta.originalDateTime;
        });
        // eslint-disable-next-line no-undef
        comp.pools[poolIndex].matches = originalOrderMatches;
      });
      this.rerender = !this.rerender;
      this.regenerateVenues('setOriginalMatchesDateTime');
    },
    getFields(venue, comp) {
      try {
        return _.get(_.find(_.get(comp, 'venues', []), (v) => v._id === venue._id), 'fields', []);
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    checkClashes() {
      this.clashes = [];
      const { drawbuilder: { timeBetweenRounds } } = this.competition;
      const allMatches = _.sortBy(this.allMatches, ['dateTime', 'venue._id', 'meta.field._id']);
      let color = 1;
      let matched = false;
      for (let i = 1; i < allMatches.length; i++) {
        const prev = allMatches[i - 1];
        const curr = allMatches[i];
        const isSameVenue = _.get(curr, 'venue._id') === _.get(prev, 'venue._id');
        const isSameFieldNo = _.get(curr, 'meta.field._id') === _.get(prev, 'meta.field._id');
        const isSameTime = _.get(curr, 'dateTime') === _.get(prev, 'dateTime') || (Math.max(_.get(curr, 'dateTime'), _.get(prev, 'dateTime')) < Math.min(+this.moment(_.get(prev, 'dateTime')).add(timeBetweenRounds, 'hours'), +this.moment(_.get(curr, 'dateTime')).add(timeBetweenRounds, 'hours')));
        if (isSameVenue && isSameFieldNo && isSameTime) {
          matched = true;

          if (!_.includes(_.map(this.clashes, '_id'), curr._id)) this.clashes.push(Object.assign(curr, { color }));
          if (!_.includes(_.map(this.clashes, '_id'), prev._id)) this.clashes.push(Object.assign(prev, { color }));
        } else if (matched) {
          matched = false;
          color++;
        }
      }
      const ref = this.$refs.tbl;
      _.forEach(ref, (r) => {
        _.forEach(r.$children, (c) => c.$forceUpdate());
      });
      return this.clashes;
    },
    checkClashesAndFixFieldNo() {
      let hasClashes = false;
      const { drawbuilder: { timeBetweenRounds } } = this.competition;
      const allMatches = _.sortBy(this.allMatches, ['dateTime', 'venue._id', 'meta.field._id', '_id']);

      const isSameVenue = (curr, prev) => _.get(curr, 'venue._id') === _.get(prev, 'venue._id');
      const isSameFieldNo = (curr, prev) => _.get(curr, 'meta.field._id') === _.get(prev, 'meta.field._id');
      const isSameTime = (curr, prev) => _.get(curr, 'dateTime') === _.get(prev, 'dateTime') || (Math.max(_.get(curr, 'dateTime'), _.get(prev, 'dateTime')) < Math.min(+this.moment(_.get(prev, 'dateTime')).add(timeBetweenRounds, 'hours'), +this.moment(_.get(curr, 'dateTime')).add(timeBetweenRounds, 'hours')));

      const findNextField = (matches, match) => {
        const venue = _.find(this.venues, (v) => v._id === _.get(match, 'venue._id')) || this.venues[0];

        if (!_.get(match, 'venue._id')) {
          const { _id, name, venueTimezone } = venue;
          // eslint-disable-next-line no-param-reassign
          match.venue = {
            _id,
            name,
            venueTimezone
          };
        }

        const sameMatches = _.filter(matches, (m) => m._id !== match._id && isSameVenue(match, m) && isSameTime(match, m));
        const usedFields = _.uniq(_.map(_.filter(sameMatches, (sm) => !!_.get(sm, 'meta.field')), (m) => _.get(m, 'meta.field._id')));

        // not in used but itself
        const currField = _.get(match, 'meta.field');
        if (currField && currField._id && !_.includes(usedFields, currField._id)) {
          return currField;
        }
        return _.find(venue.fields, (f) => !_.includes(usedFields, f._id)) || undefined;
      };

      // detech clash
      let matched = false;
      for (let i = 1; i < allMatches.length; i++) {
        const prev = allMatches[i - 1];
        const curr = allMatches[i];
        if (isSameVenue(prev, curr) && isSameFieldNo(prev, curr) && isSameTime(prev, curr)) {
          matched = true;
          // eslint-disable-next-line no-multi-assign
          prev.clashed = curr.clashed = true;
          hasClashes = true;
        } else if (matched) {
          matched = false;
        }
      }

      if (!hasClashes) return;

      _.forEach(allMatches, (m, i) => {
        if (m.clashed) {
          const nextField = findNextField(allMatches, allMatches[i]);
          allMatches[i].meta.field = nextField;
          // eslint-disable-next-line no-param-reassign
          delete m.clashed;
        }
      });

      // while (this.checkClashes().length) {
      //   this.checkClashesAndFixFieldNo();
      // }

      this.checkClashes();
    },
    tableRowClassName({ row }) {
      const clash = _.find(this.clashes, (c) => row.dateTime === c.dateTime && c.venue._id === row.venue._id && _.get(c, 'meta.field._id') === _.get(row, 'meta.field._id'));
      if (clash) {
        return `warning-row-${(clash.color % 7) }`;
      }
      return '';
    },
    dateFormatter(r, c, val) {
      return this.moment(val).format('YYYY-MM-DD');
    },
    async submit() {
      if (this.clashes.length > 0) {
        const confirm = await this.$confirm('There are some clashing matches! Are you sure you want to replace existing matches? This cannot be undone.?', 'Warning');
        if (confirm) {
          this.$emit('input', this.value);
          return true;
        }
        return false;
      }
      this.$emit('input', this.value);
      return true;
    },
    // eslint-disable-next-line func-names
    searchVenue: _.debounce(function (query) {
      if (query && query.length < 1) {
        this.venues = [];
        return;
      }
      this.$http.post('/assemble/api/v1/admin/venues/search', { criteria: query }).then((res) => {
        this.venues = res.data.data;
      }).catch(() => {});
    }, 500),
  },
  computed: {
    clearance() {
      return this.$store.getters['user/activeRoleType'];
    },
    poolsComputed() {
      if (this.rerender) {
        return this.value.pools;
      }
      return this.value.pools;
    },
  },
  watch: {
  }
};
</script>

<style lang="scss" scoped>
 ::v-deep .el-table {
  .warning-row-0 {   background: #FFC6FF;}
  .warning-row-1 {   background: #FFADAD;}
  .warning-row-2 {   background: #FFD6A5;}
  .warning-row-3 {   background: #FDFFB6;}
  .warning-row-4 {   background: #CAFFBF;}
  .warning-row-5 {   background: #9BF6FF;}
  .warning-row-6 {   background: #A0C4FF;}
  .warning-row-7 {   background: #BDB2FF;}
 }
 .stats {
  background-color: $secondary;
  color: $primary;
  box-shadow: $boxShadow;
  cursor: pointer;
  border-radius: 5px;
  .mini {
    display: flex;
    flex-direction: row;
    transition: .1s ease-out;
    div {
      color: white;
      margin: 5px 10px;
      font-size: 15px;
    }
  }
  .large {
    display: flex;
    flex-direction: row;
    div {
      color: white;
      margin: 5px 10px;
      line-height: 20px;
      font-size: 15px;
    }
  }
 }
 .venue-option {
   padding-bottom: 1.5rem;
 }
 .venue-prioritisation {
   padding-bottom: 0.5rem;
 }
</style>
